module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_006.png?f893818f610eca70da32e1badf29ca47";